<template> 
  <div style="background-color:white">
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <img src="@/assets/products/oti_1.jpg" alt="" height="400" />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <div style="padding-top:80px;padding-left:0%;">
          <div>
            <p style="font-size:36px;padding:0px;margin:0px;font-weight:200;font-family:Roboto">Gadgets Insurance</p>
            <p style="font-size:24px;padding:0px;margin:0px;font-weight:200;font-family:Roboto">(For both Business and Personal Trips)</p>
          </div>
          <div style="padding-top:20px">
            <h5>Cover:</h5>
            <p><span class="mdi mdi-check"> Financial losses due to travel changes, cancellation or interruption</span></p>
            <p><span class="mdi mdi-check"> Medical expenses, baggage delays or theft</span></p>
            <p><span class="mdi mdi-check"> Liability cover, accidental death or disability</span></p>
            <p><span class="mdi mdi-check"> Transportation delays.</span></p>
          </div>
          <div style="padding-left:25%;padding-top:15px">
            <v-btn
              color="primary"
              rounded
              outlined
              large
              @click="openDrawer(3)"        
            >
              Get a Quote
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <div style="padding-top:10px;padding-left:100px">
          <div>
            <p style="font-size:36px;padding:0px;margin:0px;font-weight:200;font-family:Roboto">Additional Benefits of OTI</p>
          </div>
          <div>
            <p style="font-size:8;font-family:Roboto">With the MyPICZ app, you can register as a client,<br />
            generate quotes, buy insurance, track claims...</p>
          </div>
          <div style="padding-top:20px">
            <p style="color:blue"><span class="mdi mdi-android"> Android</span></p>
            <p style="color:blue"><span class="mdi mdi-apple">  iPhone</span></p>
          </div>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <img src="@/assets/products/oti_2.jpg" alt="" height="500" />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <img src="@/assets/products/oti_4.jpg" alt="" height="500" />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <div style="padding-top:10px;padding-left:0px">
          <div>
            <p style="font-size:36px;padding:0px;margin:0px;font-weight:200;font-family:Roboto">OTI Claim Process</p>
          </div>
          <div>
            <p style="font-size:8;font-family:Roboto">With the MyPICZ app, you can register as a client,<br />
            generate quotes, buy insurance, track claims...</p>
          </div>
          <div style="padding-top:20px">
            <p style="color:blue"><span class="mdi mdi-android"> Android</span></p>
            <p style="color:blue"><span class="mdi mdi-apple">  iPhone</span></p>
          </div>
        </div>
      </v-col>
    </v-row>

  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'GadgetInsurance',
    components: {
      
    },
    data() {
      return {
        
      }
    },
    methods: {
      openDrawer(index){
        this.components.nav_drawer.product_index=index;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;
        
      },
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    } 
  }
</script>

